import { render, staticRenderFns } from "./createUserModal.vue?vue&type=template&id=b32d6a7e&"
import script from "./createUserModal.vue?vue&type=script&lang=js&"
export * from "./createUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports